export default "__VITE_ASSET__Co70zm4V__"